
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Plus } from "lucide-react";

interface CouponsTabProps {
  coupons: any[];
  onNewCoupon: () => void;
}

export const CouponsTab = ({ coupons, onNewCoupon }: CouponsTabProps) => {
  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={onNewCoupon}>
          <Plus className="mr-2 h-4 w-4" />
          Yeni Kupon
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Kod</TableHead>
            <TableHead>Son Kullanım</TableHead>
            <TableHead>İndirim</TableHead>
            <TableHead>Kullanım</TableHead>
            <TableHead>Max Kullanım</TableHead>
            <TableHead>Durum</TableHead>
            <TableHead>Açıklama</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {coupons.map((coupon) => (
            <TableRow key={coupon.id}>
              <TableCell className="font-medium">{coupon.code}</TableCell>
              <TableCell>{new Date(coupon.expiry_date).toLocaleDateString('tr-TR')}</TableCell>
              <TableCell>{coupon.discount_amount} TL</TableCell>
              <TableCell>{coupon.use_count}</TableCell>
              <TableCell>{coupon.max_uses || "Sınırsız"}</TableCell>
              <TableCell>
                {coupon.active ? (
                  <span className="text-green-600">Aktif</span>
                ) : (
                  <span className="text-red-600">Pasif</span>
                )}
              </TableCell>
              <TableCell>{coupon.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
